/*production*/
const CustomProductionOrder = () => import('@/views/custom/polimix/production/PolimixProductionOrder')
const CustomProductionOrderForm = () => import('@/views/custom/polimix/production/PolimixProductionOrderForm')
const CustomProductionOrderStep = () => import('@/views/custom/polimix/production/PolimixProductionOrderStep')
const CustomProductionOrderStepForm = () => import('@/views/custom/polimix/production/PolimixProductionOrderStepForm')
const CustomProductionReport = () => import('@/views/custom/polimix/production/PolimixProductionReport')
const CustomProductionKanban = () => import('@/views/custom/polimix/production/PolimixProductionKanban')
const CustomProductionLiberadosStockDetail = () => import('@/views/custom/polimix/production/PolimixProductionLiberadosStockDetail.vue')
const CustomProductionAndamentoStockDetail = () => import('@/views/custom/polimix/production/PolimixProductionAndamentoStockDetail.vue')
const CustomProductionOffSpecStockDetail = () => import('@/views/custom/polimix/production/PolimixProductionOffSpecStockDetail.vue')

/*Qualidade*/
const CustomQualityAppraisal = () => import('@/views/custom/polimix/quality/PolimixQualityAppraisal')
const CustomQualityAppraisalForm = () => import('@/views/custom/polimix/quality/PolimixQualityAppraisalForm')
const CustomQualityParamByLot = () => import('@/views/custom/polimix/quality/PolimixQualityParamByLot')
const CustomQualityParamByLotForm = () => import('@/views/custom/polimix/quality/PolimixQualityParamByLotForm')

/*stock*/
const CustomStockProduct = () => import('@/views/custom/polimix/stock/PolimixStockProduct')
const CustomStockProductManualForm = () => import('@/views/custom/polimix/stock/PolimixStockProductManualForm')
const CustomStockReport = () => import('@/views/custom/polimix/stock/PolimixStockReport')


export default {
    remove: [
        "production-order",
        "production-order-form-new",
        "production-order-form-view",
        "production-order-form-remove",
        "production-order-form",
        "production-order-step-form-view",
        "production-order-step-form",
        "production-order-step",
        "production-report",
        "stock-report",
        "stock-product",
        "stock-product-form-new",
    ],
    routes: [
        {
            path: '/custom/production/kanban',
            name: 'custom-polimix-production-kanban',
            component: CustomProductionKanban
        },
        {
            path: '/custom/production/stock-detail/liberados',
            name: 'custom-polimix-production-stock-detail-liberados',
            component: CustomProductionLiberadosStockDetail
        },
        {
            path: '/custom/production/stock-detail/andamento',
            name: 'custom-polimix-production-stock-detail-andamento',
            component: CustomProductionAndamentoStockDetail
        },
        {
            path: '/custom/production/stock-detail/off-spec',
            name: 'custom-polimix-production-stock-detail-off-spec',
            component: CustomProductionOffSpecStockDetail
        },
        /*---------------------------------------------------*/
        {
            path: '/custom/production/order/new',
            name: 'custom-polimix-production-order-form-new',
            component: CustomProductionOrderForm
        }, {
            path: '/custom/production/order/view/:id',
            name: 'custom-polimix-production-order-form-view',
            component: CustomProductionOrderForm
        }, {
            path: '/custom/production/order/remove/:id',
            name: 'custom-polimix-production-order-form-remove',
            component: CustomProductionOrderForm
        }, {
            path: '/custom/production/order/:id',
            name: 'custom-polimix-production-order-form',
            component: CustomProductionOrderForm
        },
        {
            path: '/custom/production/order',
            name: 'custom-polimix-production-order',
            component: CustomProductionOrder
        }
        /*---------------------------------------------------*/
        , {
            path: '/custom/production/order-step/view/:id',
            name: 'custom-polimix-production-order-step-form-view',
            component: CustomProductionOrderStepForm
        }, {
            path: '/custom/production/order-step/:id',
            name: 'custom-polimix-production-order-step-form',
            component: CustomProductionOrderStepForm
        }, {
            path: '/custom/production/order-step',
            name: 'custom-polimix-production-order-step',
            component: CustomProductionOrderStep
        }
        /*---------------------------------------------------*/

        , {
            path: '/custom/polimix/quality-appraisal/new',
            name: 'custom-polimix-quality-appraisal-form-new',
            component: CustomQualityAppraisalForm
        }, {
            path: '/custom/polimix/quality-appraisal/view/:id',
            name: 'custom-polimix-quality-appraisal-form-view',
            component: CustomQualityAppraisalForm
        }, {
            path: '/custom/polimix/quality-appraisal/remove/:id',
            name: 'custom-polimix-quality-appraisal-form-remove',
            component: CustomQualityAppraisalForm
        }, {
            path: '/custom/polimix/quality-appraisal/:id',
            name: 'custom-polimix-quality-appraisal-form',
            component: CustomQualityAppraisalForm
        }
        , {
            path: '/custom/polimix/quality-appraisal',
            name: 'custom-polimix-quality-appraisal',
            component: CustomQualityAppraisal
        }, {
            path: '/custom/polimix/quality-param-by-lot/new',
            name: 'custom-polimix-quality-param-by-lot-form-new',
            component: CustomQualityParamByLotForm
        }, {
            path: '/custom/polimix/quality-param-by-lot/view/:id',
            name: 'custom-polimix-quality-param-by-lot-form-view',
            component: CustomQualityParamByLotForm
        }, {
            path: '/custom/polimix/quality-param-by-lot/remove/:id',
            name: 'custom-polimix-quality-param-by-lot-form-remove',
            component: CustomQualityParamByLotForm
        }, {
            path: '/custom/polimix/quality-param-by-lot/:id',
            name: 'custom-polimix-quality-param-by-lot-form',
            component: CustomQualityParamByLotForm
        }, {
            path: '/custom/polimix/quality-param-by-lot',
            name: 'custom-polimix-quality-param-by-lot',
            component: CustomQualityParamByLot
        }, {
            path: '/custom/production/report',
            name: 'custom-polimix-production-report',
            component: CustomProductionReport
        },
        {path: '/custom/stock/report', name: 'custom-polimix-stock-report', component: CustomStockReport}
        , {
            path: '/custom/stock/product/manual',
            name: 'custom-polimix-stock-product-form-new',
            component: CustomStockProductManualForm
        }
        , {path: '/custom/stock/product', name: 'custom-polimix-stock-product', component: CustomStockProduct}

    ]
}